// @flow

export function poweredByURL (source: string): string {
  const urlBySource = {
    Chatbot: 'https://www.trbo.com/trbo-product/chat/',
    Wizard: 'https://www.trbo.com/trbo-product/advise/'
  }

  return urlBySource[source]
}
